import {DiffStats} from '@github-ui/diffs/DiffStats'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsLayoutRoute} from '../routes/layout-route'
import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {ClientOnly} from './ClientOnly'

interface DiffStatProps {
  hideSquares?: boolean
  className?: string
  bold?: boolean
}

export function DiffStat(props: DiffStatProps) {
  return (
    <ClientOnly serverFallback={<DiffStatLoadingSkeleton />}>
      <DiffStatComponent {...props} />
    </ClientOnly>
  )
}

function DiffStatComponent({hideSquares, className, bold}: DiffStatProps) {
  const {data} = useRouteQuery(pullRequestsLayoutRoute, 'diffstat')

  if (!data || !data.diffstat) {
    return null
  }

  const {diffstat} = data

  return (
    <DiffStats
      linesAdded={diffstat.linesAdded}
      linesDeleted={diffstat.linesDeleted}
      linesChanged={diffstat.linesChanged}
      hideSquares={hideSquares}
      className={className}
      bold={bold}
    />
  )
}

export function DiffStatLoadingSkeleton() {
  return <LoadingSkeleton width="80px" />
}
